import { render } from "./ResitPerbendaharaan.vue?vue&type=template&id=1d4feb80"
import script from "./ResitPerbendaharaan.vue?vue&type=script&lang=js"
export * from "./ResitPerbendaharaan.vue?vue&type=script&lang=js"

import "./ResitPerbendaharaan.vue?vue&type=style&index=0&id=1d4feb80&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__